import { useCallback } from 'react';
import { ENGINE } from '../config/eodPipeline';

const CTRL = `${ENGINE}eod_sync_control.php`;

export function useEodSyncControl() {
  const send = useCallback(async (action) => {
    const fd = new FormData();
    fd.append('action', action);
    const r = await fetch(CTRL, { method: 'POST', body: fd, credentials: 'include' });
    return r.json();
  }, []);

  return { send };
}